import { Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import { useTranslations } from "next-intl";
import { ReactNode } from "react";

export interface KeyValuePairProps extends Omit<BoxProps, "value" | "title"> {
  title: ReactNode;
  value: ReactNode;
  TypographyProps?: TypographyProps;
}

export const KeyValuePair = ({
  title,
  value,
  TypographyProps,
  ...props
}: KeyValuePairProps) => {
  const t = useTranslations();
  return (
    <Box display="flex" justifyContent="space-between" {...props}>
      <Typography
        fontSize="0.875rem"
        fontWeight="500"
        lineHeight={1}
        {...TypographyProps}
      >
        {typeof title === "string" ? t(title) : title}
      </Typography>
      <Typography
        fontSize="0.875rem"
        lineHeight={1}
        textAlign="right"
        {...TypographyProps}
      >
        {value}
      </Typography>
    </Box>
  );
};
